import styles from "./Customdropdown.module.css";
import React, { useRef, useEffect, useState } from 'react';

export const CustomDropdown = ({ 
  searchValue, 
  onSearchChange, 
  showDropdown, 
  onToggleDropdown, 
  options, 
  onSelect, 
  placeholder,
  renderOption,
  disabled = false,
  width = '200px' // Set a sensible default
}) => { 
  const dropdownRef = useRef(null);
  const [dropdownWidth, setDropdownWidth] = useState(width);

  // Update dropdown width when container width changes
  useEffect(() => {
    if (dropdownRef.current) {
      const containerWidth = dropdownRef.current.offsetWidth;
      setDropdownWidth(`${containerWidth}px`);
    }
  }, [width, showDropdown]);

  return (
    <div className={styles.customDropdown} style={{ width }} ref={dropdownRef}>
      <div className={styles.dropdownHeader} onClick={() => !disabled && onToggleDropdown(!showDropdown)}>
        <input
          type="text"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className={styles.dropdownInput}
          disabled={disabled}
        />
        {/* <span className={styles.dropdownArrow}>▼</span> */}
      </div>
      {showDropdown && (
        <div className={styles.dropdownList} style={{ width: dropdownWidth }}>
          {options.length > 0 ? (
            options.map((option, index) => (
              <div
                key={index}
                className={styles.dropdownItem}
                onClick={() => onSelect(option)}
              >
                {renderOption 
            ? renderOption(option).toLowerCase() 
            : (option.name || option.itemName || '').toLowerCase()
          }
              </div>
            ))
          ) : (
            <div className={styles.dropdownNoResults}>No results found</div>
          )}
        </div>
      )}
    </div>
  );
}